import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

export const ModalContractualesAdmin = ({
  data,
  show,
  hideModal,
  tamanio = "md",
  cerrable = true,
}) => {
  const { titulo, component } = data;

  return (
    <Modal centered show={show} size={tamanio} onHide={hideModal} backdrop="static" keyboard={cerrable} enforceFocus={false}>
      <Modal.Header
        closeButton={cerrable}
        closeVariant="white"
        className="pb-3 pt-3"
        style={{
          backgroundColor: "#2a77b9",
          borderRadius: "20px 20px 0 0",
          borderBottom: "none",
        }}
      >
        <h5 className="m-0" style={{ color: "#ffffff", fontWeight: "600" }}>{titulo}</h5>
      </Modal.Header>
      <Modal.Body className="pb-0" style={{ borderRadius: "0 0 20px 20px" }}>{component}</Modal.Body>
    </Modal>
  );
};

ModalContractualesAdmin.propTypes = {
  data: PropTypes.shape({
    titulo: PropTypes.string,
    component: PropTypes.node,
  }).isRequired,
  show: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  tamanio: PropTypes.string,
  cerrable: PropTypes.bool,
};
